import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import FloatingButtons from "../../../Components/FloatingButtons";

const Layout = () => {
  return (
    <div className="site-wrapper">
      <Header />
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  ); 
};

export default Layout;
